const OrderQuery = {
  mealManagement: 'id state updatedAt forDeliveryAt serviceFee total ' +
    '  menu { id name }' +
    '  tally { label value }' +
    '  pieces { id itemId menuId name userId userFullName instructions attributes { label value } selections price }' +
    '  venue { id name }',

  mutation: {
    pieceData(piece, attributes) {
      return {
        itemId: piece.id,
        menuId: piece.menuId,
        instructions: piece.instructions,
        selectionsHash: piece.customization,
        ...attributes,
      }
    },
  },
}

export default OrderQuery
